import { isEmpty, validAge } from "./rules";

export const validatePatientPersonalInfo = personalPatientInfo => {
  const invalid = {
    firstName: isEmpty(personalPatientInfo.firstName, "First Name"),
    lastName: isEmpty(personalPatientInfo.lastName, "Last Name"),
    gender: isEmpty(personalPatientInfo.gender, "Gender"),
    current_feets: isEmpty(personalPatientInfo.current_feets, "Height"),
    current_inches: isEmpty(personalPatientInfo.current_inches, "Height"),
    weight: isEmpty(personalPatientInfo.weight, "Weight"),
    bmi: isEmpty(personalPatientInfo.bmi, "BMI"),
    date_of_birth:
      isEmpty(personalPatientInfo.date_of_birth, "Date of Birth") ||
      validAge(personalPatientInfo.date_of_birth),

    // allergy: isAdded(personalPatientInfo.currentAllergy, "Allery"),
    // family_medical_history: isAdded(
    //   personalPatientInfo.current_family_medical_history,
    //   "Family medical history"
    // ),
    // medical_condition: isAdded(
    //   personalPatientInfo.current_medical_condition,
    //   "Medical condition"
    // ),
    // medicine_name: isAdded(
    //   personalPatientInfo.current_medicine_name,
    //   "Medicine name"
    // ),
    // medicine_timing: isAdded(
    //   personalPatientInfo.current_medicine_timing,
    //   "Medicine timing"
    // ),
    // medicine_consumption_period: isListAdded(
    //   personalPatientInfo.current_medicine_consumption_period,
    //   "Medicine consumption period"
    // ),
    // dosage: isAdded(personalPatientInfo.current_dosage, "Dosage"),
    // instructions: isAdded(
    //   personalPatientInfo.current_instructions,
    //   "Instructions"
    // ),
    // surgery_name: isAdded(
    //   personalPatientInfo.current_surgery_name,
    //   "Surgery Name"
    // ),
    // surgery_date: isAdded(
    //   personalPatientInfo.current_surgery_date,
    //   "Surgery Date"
    // ),
  };

  const valid =
    Object.keys(invalid).filter(el => invalid[el] && invalid[el].length > 0)
      .length === 0;
  if (valid) {
    invalid.personalPatientInfo = true;
  } else {
    invalid.personalPatientInfo = false;
  }
  return invalid;
};

export const validatePatientDocumentInfo = documents => {
  const invalid = {
    medical_record_name: isEmpty(
      documents.current_medical_record_name,
      "Medical record name"
    ),
    record_type: isEmpty(documents.current_record_type, "Record type"),
    examination_date: isEmpty(
      documents.current_examination_date,
      "Examination date"
    ),
    document: isEmpty(documents.current_document, "Document"),
  };

  const valid =
    Object.keys(invalid).filter(el => invalid[el] && invalid[el].length > 0)
      .length === 0;
  if (valid) {
    invalid.documents = true;
  } else {
    invalid.documents = false;
  }

  return invalid;
};

export const validatePatientContactInfo = contact => {
  console.log(contact)
  const invalid = {
    address1: isEmpty(contact.address1, "Address1"),
    city: isEmpty(contact.city, "City"),
    state: isEmpty(contact.state, "State"),
    country: isEmpty(contact.country, "Country"),
    zipcode: isEmpty(contact.zipcode, "Zipcode"),
    primary_phone: isEmpty(contact.primary_phone, "Primary Phone"),
    primaryPhoneType: isEmpty(contact.primaryPhoneType, "Primary Phone Type"),
  };

  const valid =
    Object.keys(invalid).filter(el => invalid[el] && invalid[el].length > 0)
      .length === 0;
  if (valid) {
    invalid.contact = true;
  } else {
    invalid.contact = false;
  }
  return invalid;
};

export const validatePatientDoseSpotProfile = dosespot => {
  const invalid = {
    dosespot_id: isEmpty(dosespot.dosespot_id, "e-Prescription profile"),
  };

  const valid =
    Object.keys(invalid).filter(el => invalid[el] && invalid[el].length > 0)
      .length === 0;
  if (valid) {
    invalid.dosespot = true;
  } else {
    invalid.dosespot = false;
  }
  return invalid;
};
